import React from 'react';
import moment from 'moment';
import './MessageChat.css';

export default function MessageChat({ messages = [], participantId, participantType = 'candidate', candidateId, announcement = false, showRecipient = false }) {
  return <div className="message-chat" role="log" aria-label="Histórico da conversa">
    {!messages.length && <p className="message-chat-empty">Nenhuma mensagem encontrada.</p>}
    {messages.map(item => {
      const notice = announcement || item.type_message === 'comunicado';
      const outgoing = !notice && String(item.sender_id) === String(participantId);
      const fromCandidate = participantType === 'candidate'
        ? String(item.sender_id) === String(participantId)
        : candidateId != null ? String(item.sender_id) === String(candidateId) : !outgoing && item.receive_id == null;
      return <article key={`${item.type_message || 'message'}-${item.id}`} className={`message-chat-row${outgoing ? ' is-outgoing' : ''}${notice ? ' is-announcement' : fromCandidate ? ' from-candidate' : ' from-fiscal'}`}>
        <div className="message-chat-bubble">
          <strong>{notice ? item.name_comunicado || item.name || 'Comunicado geral' : item.sender_name || item.sender?.name || 'Usuário não identificado'}</strong>
          {notice && <span className="message-chat-author">{item.sender_name || item.sender?.name}</span>}
          {showRecipient && !notice && <span className="message-chat-author">Para: {item.receive?.name || 'Fiscais da sala'}</span>}
          {item.warning && <span className="message-chat-author">Aviso</span>}
          <p>{item.message}</p>
          <time dateTime={item.created_at}>{item.created_at ? moment(item.created_at).format('DD/MM/YYYY HH:mm') : 'Data não informada'}</time>
        </div>
      </article>;
    })}
  </div>;
}
